import CachedApi from "@/commons/CachedApi.js";
import Http from "@/commons/Http";
import Utils from "@/commons/Utils.js";

const path = 'api/checklist';

export default {

  async getAll(resetCache = ''){
    return Http.get(`${path}${resetCache ? '?reset=' + resetCache : ''}`);
  },

  async getSimpleList(){
    return Http.get(`${path}/simple`);
  },

  async getAllSimpleList(){
    return Http.get(`${path}/all-simple`);
  },

  async getById(id){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}`);
  },

  async getByIdCached(id){
    return CachedApi.getCached('checklist-'+id, async () => {
      return Http.get(`${path}/${id}`);
    }, false);
  },

  async getLstTipoChecklist(){
    return Http.get(`${path}/tipo-checklist`);
  },

  async getLstChecklist(dominios){
    let params = new URLSearchParams();
    if(dominios) {
      params.append('dominios', dominios);
    }
    return Http.get(`${path}/list-checklist`, {params});
  },

  async removerFragmentos(checklist){
    return Http.post(`${path}/remover-fragmentos`, checklist);
  },

  /**
   * Estrutura de checklist resolvida da configuração vigente.
   *
   * Substitui a leitura do snapshot que vinha embutido em cada ato, certidão, protocolo,
   * documento e atividade. O backend já materializa os fragmentos e devolve `requisitos` e
   * `tipoChecklist` em camelCase — sem a divergência de grafia do snapshot, que vinha de
   * row_to_json em snake_case.
   *
   * Cacheado na sessão porque a configuração muda raramente e a mesma resolução serve todos os
   * itens do mesmo tipo de serviço: um protocolo com muitos atos faz uma requisição, não uma por
   * ato.
   */
  async resolverPorTipoServico(id, escopo = 'ATO'){
    if(!Utils.testUUID(id)){
      return [];
    }
    return CachedApi.getCached(`checklist-resolver-ts-${id}-${escopo}`, async () => {
      return Http.get(`${path}/resolver/tipo-servico/${id}`, {params: {escopo}});
    }, false);
  },

  async resolverPorTipoDocumento(id){
    if(!Utils.testUUID(id)){
      return [];
    }
    return CachedApi.getCached(`checklist-resolver-td-${id}`, async () => {
      return Http.get(`${path}/resolver/tipo-documento/${id}`);
    }, false);
  },

  async resolverPorEtapa(id){
    if(!Utils.testUUID(id)){
      return [];
    }
    return CachedApi.getCached(`checklist-resolver-et-${id}`, async () => {
      return Http.get(`${path}/resolver/etapa/${id}`);
    }, false);
  },

  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async getVinculos(checklistId){
    return Http.get(`${path}/${checklistId}/vinculos`);
  },

  async vincularTipoServico(checklistId, tipoServicoId){
    return Http.post(`${path}/${checklistId}/vincular-tipo-servico/${tipoServicoId}`);
  },

  async desvincularTipoServico(checklistId, tipoServicoId){
    return Http.delete(`${path}/${checklistId}/desvincular-tipo-servico/${tipoServicoId}`);
  },

  async vincularTodosDominio(checklistId, dominio){
    return Http.post(`${path}/${checklistId}/vincular-todos-dominio/${dominio}`);
  },

  async desvincularLote(checklistId, ids){
    return Http.post(`${path}/${checklistId}/desvincular-lote`, ids);
  },

}
